import { State } from "./state";

import type { Actions as _Actions } from "./actions";
import type { Hooks as _Hooks } from "./hooks";

export type Actions = _Actions;
export type Hooks = _Hooks;
export { State };
export abstract class Store<
  S extends State<any>,
  A extends Actions,
  H extends Hooks,
> {
  readonly state: S;
  readonly actions: A;
  readonly hooks: H;
  constructor(state: S, actions: A, hooks?: H) {
    this.state = state;
    this.actions = actions;
    this.hooks = hooks ?? ({} as H);
  }
}
